import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import type { RouterOptions } from "vue-router";
import { routers, getUserPermissNextPath } from "./index";
import useStore from "@/config/pinia";
import { getLocalData, setLocalData } from "@utils";
import { errorHandler } from "@/errorHandler/handle";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import {
  ref,
} from "vue";

function initRouter(routes: RouteRecordRaw[] = routers) {
  return createRouter({
    history: createWebHashHistory(),
    routes,
  } as RouterOptions);
}

const router = initRouter(routers);

const beforeEachRouter = async (to: any, from: any, next: any) => {
  to.fullPath = to.fullPath.replace("?isTips=2", "");
  if (to.path != "/login") {
    window.$notification.destroyAll();
  }
  const store = useStore();
  const isLogin = getLocalData("users") || false;
  let { fullPath } = to;
  const NOT_TOKEN_PATH = ["/login", "/weather", "/weatherDetails", "/demo"];
  if (fullPath.indexOf("?") > -1) {
    fullPath = fullPath.substring(0, fullPath.indexOf("?"));
  }
  if (NOT_TOKEN_PATH.includes(fullPath)) {
    document.title = import.meta.env.VITE_TITLE;
    NProgress.start();
    window.$notification.destroyAll();
    return next();
  } else if (!isLogin) {
    if (to.query['fileName']) {
      let jumpPath: any = {
        path: to.path,
        query: to.query,
      }
      setLocalData("jumpPath", jumpPath);
    }
    NProgress.start();
    window.$notification.destroyAll();
    window.$message.error("您的账号已退出，请重新登录");
    return next({
      path: "/login",
    });

  } else if (fullPath == "/permissions") {
    await store.refreshUserInfo();
    store.updateMenu();
    NProgress.start();
    next();
  } else if (fullPath == "/redirectPath") {
    await store.refreshUserInfo();
    store.updateMenu();
    NProgress.start();
    return next({
      path: getUserPermissNextPath(),
    });
  } else {
    try {
      await store.refreshUserInfo();
      store.updateMenu();
    } catch (error) {
      console.log("error", error);
    }
    const code = to.meta["code"] || "";
    if (store.getPower(code) || code == "") {
      // 如果跳转的目标页 需要参数 并且 上一页有参数，并且当前页面参数没有
      if (
        to.meta["query"] &&
        Object.keys(from.query).length != 0 &&
        Object.keys(to.query) == 0
      ) {
        for (const queryKey in to.meta["query"]) {
          to.query[queryKey] = from.query[to.meta.query[queryKey]];
        }
        NProgress.start();
        return next({ path: to.path, query: to.query });
      }
      NProgress.start();
      return next();
    } else {
      NProgress.start();
      return next({
        path: "/permissions",
      });
    }
  }
};
let tips_show_status: any = ref(false)
router.beforeEach((to: any, from, next) => {
  const store = useStore();
  let isTips = to.query["isTips"] || 1;
  const needConfirmRoute =
    (from.name == "addInquiries" &&
      !["addInquiries", "login"].includes(to.name) &&
      isTips == 1) ||
    (from.name == "addSchedulingLInfo" &&
      !["login"].includes(to.name) &&
      isTips == 1) ||
    (from.name == "addSchedulingList" &&
      !["login"].includes(to.name) &&
      isTips == 1);
  // 仅当“需要确认的路由”且“该页有修改”时才弹窗；addInquiries 暂不按备份比较，保持原逻辑（离开即提示）
  const isDirty =
    from.name === "addInquiries" || store.routeFormDirty[from.name] === true;

  if (needConfirmRoute && isDirty) {
    if (!tips_show_status.value) {
      tips_show_status.value = true;
      window.$dialog.info({
        title: "提示",
        content: `当前页面未保存，是否确认离开？`,
        positiveText: "确认",
        negativeText: "取消",
        // maskClosable: false,
        closeOnEsc: false,
        // closable: false,
        onPositiveClick: () => {
          beforeEachRouter(to, from, next);
          tips_show_status.value = false;
          if (from.name === "addSchedulingLInfo" || from.name === "addSchedulingList") {
            store.setRouteFormDirty(from.name, false);
          }
          return;
        },
        onNegativeClick: () => {
          tips_show_status.value = false;
        },
        onMaskClick: () => {
          tips_show_status.value = false;
        },
        onClose: () => {
          tips_show_status.value = false;
        }
      });
    }
  } else {
    beforeEachRouter(to, from, next);
    tips_show_status.value = false;
  }
});

router.onError((error, to) => {
  errorHandler.getErrorCodeHandler(error.message);
});
router.afterEach((to, from) => {
  // 离开排期相关页时清空 dirty，避免下次进入其他页再回来仍显示未保存
  if (from.name === "addSchedulingLInfo" || from.name === "addSchedulingList") {
    useStore().setRouteFormDirty(from.name, false);
  }
  NProgress.done();
});
export { router, initRouter };
